import { Injectable } from '@angular/core';

import { StorageService } from './storage.service';

@Injectable({
    providedIn: 'root'
})
export class SessionService {
    private readonly tokenKey = 'avalonSurveys';

    constructor(
        private storageService: StorageService,
    ) {}

    public saveSessionId(token: string): void {
        this.storageService.saveData(this.tokenKey, token);
    }

    public getSessionId(): string | null {
        return this.storageService.getData(this.tokenKey);
    }

    public removeSessionId(): void {
        this.storageService.removeData(this.tokenKey);
    }
}
